import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NotesService } from '../notes.service';

import { ListNotesService } from '../list.service';
import { TranslateService } from '@ngx-translate/core';
import { ProjectsService } from '../../services/projects-proposals-service/projects-proposals.service';

@Component({
  selector: 'mcrit-gestio-notes-filters',
  templateUrl: 'notes-filters.component.html',
  styleUrls: ['notes-filters.component.css'],
  providers: [ ProjectsService ]
})
export class NotesFiltersComponent implements OnInit {
  @Input() validFilters: Array<any>;
  @Output() changeFilter = new EventEmitter();

  public filterModel: any;
  public dataLists: Array<any>;

  constructor(public translate: TranslateService, private listNotesService: ListNotesService,private notesService: NotesService,private projectsService: ProjectsService) {}

  public sendActiveFilters() {
    const activeFilters = {};
    this.listNotesService.valFiltres={};

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => this.listNotesService.valFiltres[key] = this.filterModel[key]);

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => activeFilters[key] = this.listNotesService.valFiltres[key]);

    this.changeFilter.emit(activeFilters);
  }

  public resetActiveFilters() {
    this.listNotesService.valFiltres={};

    this.filterModel = {};
    this.sendActiveFilters();
  }

  ngOnInit() {
    let requestedAutocompletes = [];
    this.filterModel = this.validFilters.reduce((acum, curr) => {
        curr.inputs.forEach(inputGroup => {
          switch (inputGroup.type) {
            case 'select':
              acum[inputGroup.name] = (inputGroup.value ? inputGroup.value : null);
              break;
            default:
            inputGroup.values.forEach(input => {
              if(input.autocomplete)requestedAutocompletes.push(input.autocomplete);
              acum[input.name] = (input.value ? input.value : null);
            });
          }
        });

      return acum;
    }, {});
    //Omple els valors per defecte dels camps autocomplete
    this.dataLists = requestedAutocompletes.map(id => { return { id: id, options: this.projectsService.getAutocomplete(id) }; });

    //Quan tenim una cerca desada
    if(Object.keys(this.listNotesService.activeFilters).length !== 0)this.filterModel = this.listNotesService.activeFilters;
    this.sendActiveFilters();
  }

}
